// -----------------------------------------------------------------------------
// EntryTariffKisCard — Discover Uni TARIFF, per-course UCAS-points distribution.
//
// Shows the actual points distribution of entrants to *this specific course*,
// not the uni-wide advertised floor. Data comes from
// `degree.tariff_kis` populated by scripts/ingest_teaching_learning `dui` kind.
// -----------------------------------------------------------------------------
import React from "react";

const fmt = (n) => (typeof n === "number" ? n.toLocaleString() : "—");

export function EntryTariffKisCard({ degree }) {
  const t = degree?.tariff_kis;
  if (!t?.bands?.length) return null;
  const maxPct = Math.max(...t.bands.map((b) => b.pct));
  return (
    <div
      data-testid="entry-tariff-kis-card"
      className="rounded-lg border border-stone-200 bg-white p-5 mt-4"
    >
      <div className="flex items-baseline gap-2 mb-2">
        <div className="text-[10px] font-underground-sc tracking-wider text-[#7C3AED]">
          UCAS Tariff · this course
        </div>
      </div>
      <div className="flex items-baseline gap-4 mb-3">
        <div className="font-serif text-4xl text-stone-900" data-testid="tariff-weighted-mean">
          {fmt(t.weighted_mean_pts)}
        </div>
        <div className="text-[11px] font-underground-sc tracking-wider text-stone-500 leading-tight">
          <div>Typical entrant</div>
          <div className="normal-case tracking-normal text-stone-500">
            weighted mean · n={fmt(t.pop)}
          </div>
        </div>
      </div>
      {/* Points band distribution — horizontal bars, one per band */}
      <div className="space-y-1.5" data-testid="tariff-bands">
        {t.bands.map((b, i) => {
          const isTop = t.top_band && t.top_band.points === b.points;
          return (
            <div key={i} className="flex items-center gap-3 text-[11px]">
              <div className="w-14 font-mono text-stone-600 text-right flex-shrink-0">
                {b.points}+
              </div>
              <div className="flex-1 h-3 bg-stone-100 rounded relative">
                <div
                  className={`h-3 rounded ${isTop ? "bg-[#7C3AED]" : "bg-stone-400"}`}
                  style={{ width: `${(b.pct / maxPct) * 100}%` }}
                  title={`${b.pct}% of entrants scored ${b.points}+ UCAS points`}
                />
              </div>
              <div className="w-10 text-right font-mono text-stone-800">
                {b.pct}%
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-3 text-[10px] font-underground-sc tracking-wider text-stone-400">
        {t.cohort_year} entry cohort · Discover Uni TARIFF
      </div>
    </div>
  );
}

export default EntryTariffKisCard;
